import { fonts } from '~/src/helpers/font';
import { EElementType, ILandingElement } from '~/src/services/projects';

export const Footer2: ILandingElement = {
    title: 'Footer2',
    type: EElementType.Block,
    label: 'Нижний блок с тарифами',
    properties: {
        blockName: '',
        customStyles: 'background: #F7F7F7',
        sortOrder: '',
        background: '',
        backgroundWebp: '',
        marginTop: '',
        marginBottom: '',
    },
    children: [
        {
            title: 'Title',
            type: EElementType.RTE,
            label: 'Заголовок',
            properties: {
                customize: {
                    font: fonts.H1,
                    color: '#1A1A1A',
                    textAlign: 'left',
                    tag: '',
                },
                htmlContent: 'Заголовок',
                customStyles: 'white-space: pre-wrap;',
            },
        },
        {
            title: 'SubTitle',
            type: EElementType.RTE,
            label: 'Подзаголовок',
            properties: {
                customize: {
                    font: fonts.S,
                    color: '#1A1A1A',
                    textAlign: 'left',
                    tag: '',
                },
                htmlContent: 'Подзаголовок',
                customStyles: `margin-top: 5px;
                margin-bottom: 32px;
                max-width: 100%;`,
            },
        },
        {
            title: 'Form',
            type: EElementType.InstallmentTariffForm,
            label: 'Форма с ценой',
            properties: {
                customize: {
                    alias: '',
                },
                phonePlaceholder: 'Номер телефона',
                buttonText: 'Подключить тариф',
                buttonBackgroundColor: '',
                buttonBackgroundHoverColor: '',
                buttonTextColor: '',
                customStyles: '',
            },
            children: [{
                title: 'Button',
                type: EElementType.Button,
                label: 'Кнопка',
                properties: {
                    customStyles: '',
                    isTargetBlank: false,
                },
                children: [
                    {
                        title: 'Text',
                        type: EElementType.Text,
                        label: 'Текст',
                        properties: {
                            customize: {
                                font: fonts.Medium,
                                color: '#FFF',
                                href: '',
                            },
                            content: 'Подключить',
                            customStyles: '',
                        },
                    },
                ],
            }],
        },
        {
            title: 'Image',
            type: EElementType.Image,
            label: 'Изображение',
            properties: {
                content: '',
                webp: '',
                alt: '',
                customStyles: '',
            },
        },
    ],
};
